/**
 * FlyoutExpandIcon/index.js
 * desc: icon to expand flyout content
 * note: entity icon via IconButton; defaults its tooltip + accessible name to the
 *       icon label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const FlyoutExpandIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="flyout-expand icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.flyoutExpand.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 25 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.17 11.17l-.139 8.346-8.346.139 2.545-2.546-2.462-2.462 3.394-3.394 2.463 2.462 2.545-2.546zm-9.614-4.52l2.463 2.463-3.394 3.394-2.463-2.463-2.545 2.546.138-8.347 8.347-.138-2.546 2.545z"/></svg>
    </IconButton>
);


export default FlyoutExpandIcon;
